import React from "react";

import DocumentCard from "./DocumentCard";
import DocumentsEmptyState from "./DocumentsEmptyState";
import DocumentsSkeleton from "./DocumentsSkeleton";

export default function DocumentsList({ items = [], loading, onOpen }) {
  if (loading) {
    return <DocumentsSkeleton />;
  }

  if (!items.length) {
    return <DocumentsEmptyState />;
  }

  return (
    <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {items.map((item, index) => (
        <DocumentCard
          key={item.id}
          item={item}
          onOpen={onOpen}
          delay={Math.min(index * 35, 180)}
        />
      ))}
    </div>
  );
}